

export function alphabeticalSort(a: string, b: string, reverse = true)
{
  return b.localeCompare(a) * (reverse ? -1 : 1);
}

export function timestampToSeconds(timestamp: string)
{
  const hms = timestamp.split(':').map(str => Number(str));

  return hms[0] * 3600 + hms[1] * 60 + hms[2];
}

export function sToTimestamp(seconds: number)
{
  return (
    String(Math.floor(seconds / 3600)).padStart(2, '0') + ":" +
    String(Math.floor((seconds % 3600) / 60)).padStart(2, '0') + ":" +
    String(Math.floor(seconds % 60)).padStart(2, '0'));
}

export function formatDate(date: Date)
{
  const now = new Date();

  const diffMs = now.getTime() - date.getTime();
  const dayMs = 24 * 60 * 60 * 1000;

  // In the last day
  if(diffMs < dayMs)
    return String(date.getHours()) + ":" + date.getMinutes();
  // Last 2 days
  if(diffMs <= 2 * dayMs)
    return "yesterday, " + date.toLocaleTimeString();
  // Within the last week
  if(diffMs <= 7 * dayMs)
    return String(Math.round(diffMs / dayMs)) + " days ago";
  // This year
  if(date.getFullYear() === now.getFullYear())
    return String(date.getMonth() + 1) + "/" + date.getDate();

  return String(date.getFullYear() + 1) + "/" + (date.getMonth() + 1) + "/" + date.getDate();
}

export function composeTaxBreakdown(
  listing: {
    baseTax: number,
    taxPercent?: number,
    taxBracketEnd?: number,
    taxEstimated?: boolean,
    salesTax?: number },
  userCurrencySymbol: string)
{
  const baseTax = listing.baseTax;
  const taxPercent = listing.taxPercent;
  const taxBracketEnd = listing.taxBracketEnd;

  if(!taxPercent && !baseTax)
    return;

  let text = "Tax @ ";
  if(baseTax)
    text += userCurrencySymbol + baseTax.toFixed(2);
  if(baseTax && taxPercent)
    text += " + ";
  if(taxPercent)
    text += taxPercent.toFixed(0) + "%";
  if(listing.taxEstimated)
    text += " (est.)";
  if(taxBracketEnd)
    text += " for orders <" + userCurrencySymbol + taxBracketEnd.toFixed(2);
  if(listing.salesTax)
    text += " + " + listing.salesTax + "% sales tax";

  return text;
}

export function composeDeliveryBreakdown(
  listing: {
    listingCurrencySymbol: string,
    vendorCurrencySymbol: string,
    deliveryPerListing?: number,
    deliveryPrice?: number,
    deliveryPriceEstimated?: boolean })
{
  if(!listing.deliveryPerListing && !listing.deliveryPrice)
    return;

  let text = "\nDelivery @ ";
  if(listing.deliveryPerListing)
    text += listing.listingCurrencySymbol + listing.deliveryPerListing.toFixed(2) + " per listing";
  if(listing.deliveryPrice && listing.deliveryPerListing)
    text += " + ";
  if(listing.deliveryPrice)
    text += listing.vendorCurrencySymbol + listing.deliveryPrice.toFixed(2) + " per order";
  if(listing.deliveryPriceEstimated && listing.deliveryPrice)
    text += " (est.)";

  return text;
}

export function productDesc(product: {
  brandName: string,
  productName: string,
  amount: number,
  amountUnit: string })
{
  return (
    product.brandName + ' ' +
    product.productName + ' ' +
    '(' + product.amount + ' ' + product.amountUnit + ')');
}

export function trimTrailing0s(num: number)
{
  let formatted = num.toString();

  // Remove trailing zeros after the decimal point
  if(formatted.indexOf('.') !== -1)
    formatted = formatted.replace(/(?:\.0*|(\.\d+?)0+)$/, '$1');

  return formatted;
}

export function max2Sf(num?: number | string)
{
  if(typeof num === "string")
    num = parseFloat(num);
  else if(num === undefined)
    return undefined;

  const replaced = String(num.toFixed(2))
    .replace(/^\./, "0.");

  const numStringNumToFixed = Number(replaced);

  return String(numStringNumToFixed);
}
